/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import DataGridColumn from "./DataGridColumn";
import { FlexGridCellTemplate } from "@grapecity/wijmo.react.grid";
import { useEffect, useState } from "react";


// Form Item Type Select에 대응하는 Custom DataGridColumn

function DataGridTableNameColumn ( props ) {

    const { schema, ...others } = props;

    const [ cellTemplate, setCellTemplate ] = useState ( ( ctx ) => {
        return <></>;
    } );

    const { t } = useTranslation();

    useEffect ( () => {

        setCellTemplate ( () => ( ( ctx ) => {

            if ( schema ) {

                return (
                    <>
                        <span>{ t ( `tableName.${ctx.item[schema.name] || schema.defaultValue}` ) }</span>
                    </>
                );

            } else {

                return <></>;

            }

        } ) );

    }, [schema] );

    return (

        <DataGridColumn schema={schema} {...others} >
            <FlexGridCellTemplate cellType="Cell" template={cellTemplate} />
        </DataGridColumn>

    );

}

export default DataGridTableNameColumn;

